// config.ts
export const API_BASE_URL = '/api';
export const APP_DOMAIN = 'wholesale.stickysaguaro.com';